import { isValidPhoneNumber } from 'libphonenumber-js';

export const isValidURL = (url: string) => {
  const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
  const domainRE = /^[^\s.]+\.\S{2,}$/;

  if (typeof url !== 'string') {
    return false;
  }

  const match = protocolAndDomainRE.exec(url);
  if (!match) {
    return false;
  }

  const [everythingAfterProtocol] = match;

  if (!everythingAfterProtocol) {
    return false;
  }

  if (domainRE.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
};

export const validate = {
  phone: (value: string | undefined) => {
    if (!!value && !isValidPhoneNumber(value)) {
      return 'Invalid phone number';
    }
    return null;
  },

  website: (value: string | undefined) => {
    if (!value || !value.trim()) {
      return 'Required';
    }

    if (!isValidURL(value)) {
      return 'Invalid URL';
    }

    return null;
  },
};
